/* ============================================================
   FF EAI-Robotics — QS_ Cookies + URL Params to Cart Attributes
   ============================================================ */

(function () {
  'use strict';

  const CONFIG = {
    COOKIE_PREFIX: 'qs_',
    ATTRIBUTE_PREFIX: '_',        // 推荐保留，属性会变成 _qs_xxx 或 _test
    DEBUG: false                   // 上线前改为 false
  };

  function log(...args) {
    if (CONFIG.DEBUG) console.log('[QS Sync]', ...args);
  }

  // ==================== 获取 Cookies ====================
  function getAllCookies() {
    const cookies = {};
    document.cookie.split(';').forEach(cookie => {
      const [name, ...rest] = cookie.trim().split('=');
      if (name) {
        cookies[name] = decodeURIComponent(rest.join('='));
      }
    });
    return cookies;
  }

  // ==================== 获取 URL Query 参数 ====================
  function getUrlParams() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);
    
    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }
    return params;
  }

  // ==================== 更新 Cart ====================
  async function updateCartAttributes(attributes) {
    if (Object.keys(attributes).length === 0) return null;

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      log('✅ Cart attributes updated:', attributes);
      return data;
    } catch (err) {
      console.error('[QS Sync] Failed to update cart attributes:', err);
      return null;
    }
  }

  // ==================== 主同步函数 ====================
  async function syncToCart() {
    const allCookies = getAllCookies();
    const urlParams = getUrlParams();
    const attributes = {};

    // 1. 处理 qs_ 开头的 Cookie
    Object.entries(allCookies).forEach(([name, value]) => {
      if (name.startsWith(CONFIG.COOKIE_PREFIX)) {
        const attrKey = CONFIG.ATTRIBUTE_PREFIX ? CONFIG.ATTRIBUTE_PREFIX + name : name;
        attributes[attrKey] = value;
        log(`Found qs_ cookie → ${attrKey} = ${value}`);
      }
    });

    // 2. 处理 URL Query 参数（重点新增）
    Object.entries(urlParams).forEach(([key, value]) => {
      const attrKey = CONFIG.ATTRIBUTE_PREFIX ? CONFIG.ATTRIBUTE_PREFIX + key : key;
      attributes[attrKey] = value;
      log(`Found URL param → ${attrKey} = ${value}`);
    });

    if (Object.keys(attributes).length === 0) {
      log('No qs_ cookies or URL params found');
      return;
    }

    await updateCartAttributes(attributes);
  }

  // ==================== 初始化 ====================
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncToCart);
    } else {
      syncToCart();
    }

    // Shopify Cart 事件监听
    const cartEvents = [
      'cart:open', 'cart:updated', 'cart:change', 'cart:refresh',
      'ajax-cart:updated', 'cart:items:added'
    ];

    cartEvents.forEach(event => {
      document.addEventListener(event, () => {
        if (window.qsSyncTimeout) clearTimeout(window.qsSyncTimeout);
        window.qsSyncTimeout = setTimeout(syncToCart, 300);
      });
    });

    // MutationObserver 增强
    const observer = new MutationObserver(() => {
      if (document.querySelector('[data-cart-drawer], .cart-drawer, #CartDrawer, .cart__contents')) {
        syncToCart();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    log('🚀 QS Cookies + URL Params Sync initialized');
  }

  init();
})();